(function () {
  const MOBILE_MEDIA_QUERY = window.matchMedia("(max-width: 719px)");

  function centerActiveVariantPill() {
    if (!MOBILE_MEDIA_QUERY.matches) return;

    document.querySelectorAll(".product-block-metaobject-product-variants__grid--carousel").forEach((carousel) => {
      const active = carousel.querySelector(".product-block-metaobject-product-variants__card.active");
      if (!active) return;

      const target = active.offsetLeft - carousel.clientWidth / 2 + active.clientWidth / 2;
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;

      carousel.scrollLeft = Math.max(0, Math.min(target, maxScroll));
    });
  }

  function scheduleCenterActiveVariantPill() {
    requestAnimationFrame(centerActiveVariantPill);
  }

  function debounce(fn, wait) {
    let timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(fn, wait);
    };
  }

  scheduleCenterActiveVariantPill();

  window.addEventListener("orientationchange", scheduleCenterActiveVariantPill);
  window.addEventListener("resize", debounce(scheduleCenterActiveVariantPill, 150));
})();
